import { useSyncExternalStore } from "react";

let showing = false;
const listeners = new Set<() => void>();

export function showsHere(showing: boolean, narrow: boolean): boolean {
  return narrow ? showing : true;
}

export function nowShowing(): boolean {
  return showing;
}

export function showDetails(next: boolean): void {
  showing = next;
  for (const listener of listeners) listener();
}

export function subscribeShowing(listener: () => void): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

export function forgetShowing(): void {
  showing = false;
}

export function useShowing(): boolean {
  return useSyncExternalStore(subscribeShowing, nowShowing, () => false);
}
